import React, {  useState } from "react";
import { Button, Modal, Space } from "antd";
import { SelectDepart, SelectEmployee, SelectInput } from "../SelectInput";
import DatePickerComponent from "../DatePicker";
import {  useSelector } from "react-redux";

const ModalComponents = ({ titles, emloyeeList, message, setIsOpen, isOpen, setName }) => {
  const { allEmployee } = useSelector((state) => state.employees);
  const { allDept = [] } = useSelector((state) => state.employees || []);
  const { users } = useSelector((state) => state.user || {});
  const [open, setOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("All");
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const url = titles.split(" ").join("");

   const uniqueDepartments = Array.isArray(allDept)
  ? [
      ...new Map(
        allDept
          .filter(item => item?.DEPT && item?.CODE) // ⬅️ safety
          .map(item => [
            item.DEPT.trim() + item.CODE,
            { DEPT: item.DEPT.trim(), CODE: item.CODE }
          ])
      ).values()
    ]
  : [];
  const filterEmployee = Array.isArray(allDept)
  ? allDept.filter(empl => empl?.CODE === selectedDepartment)
  : [];
  const isAuth = users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant" 

  const showModal = () => {
    setOpen(true);
  };
  // Old
  // const handleOk = async () => {
  //   try {
  //     if (titles === "Attendance Sheet" || titles === "Monthly Report") {
  //       dispatch(fetchingEmployeeStart());
  //       let route;
  //       let obj;
  //       // remove data.role
  //       if (isAuth && selectedDepartment == "All") {
  //        // remove data.role
  //         route = isAuth && selectedDepartment == "All" && "getAllEmployeesAttendance"
  //         obj = {
  //           todate: toDate,
  //           fromdate: fromDate,
  //         };
  //       } else if (selectedEmployee === "All") {
  //         // console.log("department",selectedDepartment)
  //         // remove data.role
  //         route = `${isAuth ?
  //           `${selectedDepartment ? `getAllEmployeesAttendance?departmentcode=${selectedDepartment}` : "getAllEmployeesAttendance"}` :
  //           "getAllEmployeesAttendance?departmentcode=5"}`;
  //         obj = {
  //           todate: toDate,
  //           fromdate: fromDate,
  //         };
  //       } else {
  //         route = "getByEmpId";
  //         obj = {
  //           empid: selectedEmployee,
  //           todate: toDate,
  //           fromdate: fromDate,
  //         };
  //       }
  //       if (toDate && fromDate) {
  //         setOpen(false);
  //         setSelectedEmployee("All");
  //         setSelectedDepartment("All");
  //         dispatch(reduxToDate(toDate));
  //         dispatch(reduxFromDate(fromDate));
  //         setToDate("");
  //         setFromDate("");
  //         // navigate(`/${url}`); 
  //         window.open(`/${url}`, '_blank')
  //         setIsOpen(!isOpen)      
  //         try {
  //            const response = await postRequest(route, obj);
  //           //  console.log("get all att API response ==>>>",response);
  //            dispatch(fetchingEmployeeSuccess(response));
  //         } catch (error) {
  //            console.error("Error in API request:", error);
  //         }
  //      }
       
  //     } else if (titles === "All Employee") {
  //       dispatch(fetchingEmployerStart());
  //       const route = "getAllEmployeesAttendance?departmentcode=5";
  //       const dates = {
  //         todate: toDate,
  //         fromdate: fromDate,
  //       };
  //       if (toDate && fromDate) {
  //         setOpen(false);
  //         setSelectedEmployee("");
  //         dispatch(reduxToDate(toDate));
  //         dispatch(reduxFromDate(fromDate));
  //         setToDate("");
  //         setFromDate("");
  //         // navigate(`/${url}`);
  //         window.open(`/${url}`, '_blank')
  //         setIsOpen(!isOpen)
  //         const response = await postRequest(route, dates);
  //         dispatch(fetchingEmployerSuccess(response));
  //       }
  //     }
  //   } catch (error) { }
  // };

  // new 
  const handleOk = async () => {
  try {
    if (titles === "Attendance Sheet" ||titles === "Attendance Records"  || titles === "Monthly Report") {
      if (toDate && fromDate) {
        // Parameters ko query string ke through bhej do
        const queryParams = new URLSearchParams({
          fromDate,
          toDate,
          department: selectedDepartment,
          employee: selectedEmployee,
        }).toString();

        setOpen(false);
        setSelectedEmployee("All");
        setSelectedDepartment("All");
        setToDate("");
        setFromDate("");

        // New tab open with query params
        window.open(`/${url}?${queryParams}`, '_blank');
        setIsOpen(!isOpen);
      }
    } else if (titles === "All Employee") {
      if (toDate && fromDate) {
        const queryParams = new URLSearchParams({
          fromDate,
          toDate,
          department: selectedDepartment,
        }).toString();

        setOpen(false);
        setSelectedEmployee("");
        setToDate("");
        setFromDate("");

        window.open(`/${url}?${queryParams}`, '_blank');
        setIsOpen(!isOpen);
      }
    }
  } catch (error) {
    console.error("Error opening report:", error);
  }
};

  const handleCancel = () => {
    setOpen(false);
    // setIsOpen(!isOpen)
  };
  const pickEmployee = (value, label) => {
    setSelectedEmployee(value);
    setName(label.label)
  };
  const pickDepartement = (value) => {
    setSelectedDepartment(value);
  };
  const pickToDate = (date, dateString) => {
    setToDate(dateString);
  };
  const pickFromDate = (date, dateString) => {
    setFromDate(dateString);
  };

  return (
    <>
      {isAuth ? (
        <>
          <Space className="border-none w-full "  onClick={showModal}>
            {message ? (
              <span
                className="font-semibold text-[16px] bg-transparent border-0 text-inherit"
                // onClick={showModal}
              >
                {titles}
              </span>
            ) : (
              <span className="   hover:cursor-pointer px-3 py-2.5 rounded-xl bg-[#54559E] flex flex-wrap  hover: text-white hover:scale-105" 
              // onClick={showModal}
              >
                {titles}
              </span>
            )}
          </Space>
          <Modal
          centered
            open={open}
            className=" mt-20 lg:mt-14"
            onOk={() => handleOk()}
            // onOk={handleOk}
            onCancel={handleCancel}
            footer={(_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            )}
          >
            <h1 className="my-2 font-bold text-center text-[17px] text-gray-700">{titles}</h1>
            <h2 className="my-2 font-semibold text-[17px] text-gray-700">Select Department</h2>
            <SelectDepart
            allLabel={{ value: 'All', label: 'All' }}
              departList={uniqueDepartments || []}
              onChange={pickDepartement}
              selectedDepartment={selectedDepartment}
            />
            <h2 className="my-2 font-semibold text-[17px] text-gray-700">Select Employee</h2>
            <SelectEmployee
              employeeList={filterEmployee || []}
              onChange={pickEmployee}
              selectedEmployee={selectedEmployee}
              allLabel={ { value: 'All', label: 'All' }}
            />
            <div className="flex w-full py-5">
              <div className="flex flex-col w-1/2">
                <label className="font-semibold">From</label>
                <DatePickerComponent onChange={pickFromDate} date={fromDate} />
              </div>
              <div className="flex flex-col w-1/2">
                <label className="font-semibold">To</label>
                <DatePickerComponent onChange={pickToDate} date={toDate} />
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <>
          <Space>
            {message ? (
              <Button
                className="font-semibold text-[16px] bg-transparent border-0 text-inherit"
                onClick={showModal}
              >
                {titles}
              </Button>
            ) : (
              <span className="px-4 py-2.5 rounded-xl bg-[#54559E] hover:cursor-pointer  text-white hover:scale-110 font-semibold" onClick={showModal}>
                {titles}
              </span>
            )}
          </Space>

          <Modal
            open={open}
            title={
              titles === "Attendance Sheet"
                ? "Select Employee"
                : "Departmentwise"
            }
            onOk={handleOk}
            style={{ overflow: "visible" }}
            onCancel={handleCancel}
            footer={(_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            )}
          >
            {titles === "All Employee" ? (
              <div>
                <h3 className="text-xl font-semibold text-center bg-black text-white w-fit mx-auto px-5 py-2">
                  IT Enable Services
                </h3>
              </div>
            ) : (
              <SelectInput
                emloyeeList={allEmployee}
                onChange={pickEmployee}
                selectedEmployee={selectedEmployee}
              />
            )}
            <div className="flex w-full py-5">
              <div className="flex flex-col w-1/2">
                <label className="font-semibold">From</label>
                <DatePickerComponent onChange={pickFromDate} date={fromDate} />
              </div>
              <div className="flex flex-col w-1/2">
                <label className="font-semibold">To</label>
                <DatePickerComponent onChange={pickToDate} date={toDate} />
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};
export default ModalComponents;
